import { IApplicationState } from '../../types/redux';

export function selectDropdownOpen(state: IApplicationState): boolean {
  return state.dropdown.open;
}
